import { extendTheme } from '@chakra-ui/react';

import Button from './components/buttonTheme';
import Checkbox from './components/checkboxTheme';
import Container from './components/containerTheme';
import FormLabel from './components/formLabelTheme';
import Input from './components/inputTheme';
import Link from './components/linkTheme';
import Menu from './components/menuTheme';
import Modal from './components/modalTheme';
import PinInput from './components/pinInputTheme';
import Progress from './components/progressTheme';
import Switch from './components/switchTheme';
import Text from './components/textTheme';
import Textarea from './components/textareaTheme';
import Tooltip from './components/tooltipTheme';
import breakpoints from './foundations/breakpoints';
import colors from './foundations/colors';
import fonts from './foundations/fonts';
import sizes from './foundations/sizes';
import styles from './styles';

const customTheme = extendTheme({
  styles,
  breakpoints,
  fonts,
  colors,
  sizes,
  components: {
    Tooltip,
    Textarea,
    Text,
    Switch,
    Progress,
    PinInput,
    Modal,
    Menu,
    Link,
    Input,
    FormLabel,
    Container,
    Checkbox,
    Button,
  },
});

export default customTheme;
